import React from 'react';
import Loader from '@/components/Layout/Loader';
import { isDynamicImportError, reloadOnce } from '@/utils/dynamicImportReload';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
  reloadSuppressed: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null, reloadSuppressed: false };

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return { error };
  }

  componentDidCatch(error: Error) {
    if (isDynamicImportError(error) && !reloadOnce()) {
      this.setState({ reloadSuppressed: true });
    }
  }

  render() {
    const { error, reloadSuppressed } = this.state;

    if (error) {
      if (isDynamicImportError(error) && !reloadSuppressed) {
        return <Loader />;
      }
      throw error;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
